export const keywordDifficulty = [
  {
    index: 0,
    difficulty: "Low",
    info: "Competitor channels are just starting to learn about YouTube SEO and may not be implementing best practices consistently.",
  },
  {
    index: 1,
    difficulty: "Medium",
    info: "Competitor channels have some experience with YouTube SEO and are using some best practices, but there is still room for improvement.",
  },
  {
    index: 2,
    difficulty: "High",
    info: "Competitor channels have greatv experience with Youtube SEO and are using the best of practices",
  },
];

export const competitorChannelSize = [
  {
    index: 0,
    difficulty: "Small",
    info: "Competitor channels have a small number of subscribers (medianInfo), which makes it very easy for you to compete for search visibility and audience attention. Consider creating high-quality, engaging content and utilizing social media and other marketing strategies to improve your ranking.",
  },
  {
    index: 1,
    difficulty: "Medium",
    info: "Competitor channels have a fair number of subscribers (medianInfo), which can makes not so challenging to compete for search visibility and audience attention. Consider creating high-quality, engaging content and utilizing social media and other marketing strategies to improve your ranking.",
  },
  {
    index: 2,
    difficulty: "Large",
    info: "Competitor channels have a large number of subscribers (medianInfo), which can make it very challenging to compete for search visibility and audience attention. Consider creating high-quality, engaging content and utilizing social media and other marketing strategies to improve your ranking.",
  },
];

export const ageOfTopVideos = [
  {
    index: 0,
    difficulty: "Low",
    info: "Video uploads covering this topic are relatively low. You should find it easy to rank for this search query. Consider targeting more long-tail or niche keywords, and creating high-quality and unique content to stand out from competitors.",
  },
  {
    index: 1,
    difficulty: "Medium",
    info: "There are a few recent video uploads covering the topic. You shouldn't find it too difficult to rank for this search query. Consider targeting more long-tail or niche keywords, and creating high-quality and unique content to stand out from competitors.",
  },
  {
    index: 2,
    difficulty: "High",
    info: "There are many recent video uploads covering the topic. You may find it difficult to rank for this search query. Consider targeting more long-tail or niche keywords, and creating high-quality and unique content to stand out from competitors.",
  },
];
